import { fork, put, call, take } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';

import { acceptError } from 'common/_redux';
import * as actionTypes from './actions';
import { getAllConfigList } from '../../business-alerts/api';

function* getAllClientConfigListSaga() {
  try {
    const responseData = yield call(getAllConfigList, 'client');
    yield put(actionTypes.getAllClientConfigList.success(responseData?.detail || []));
  } catch (error) {
    yield put(acceptError(error.message || 'Failed to load client alert settings', true));
    yield put(actionTypes.getAllClientConfigList.failure());
  }
}

function* getAllClientConfigListWatcherSaga() {
  while (true) {
    yield take(actionTypes.GET_ALL_CLIENT_CONFIG_LIST[REQUEST]);
    yield call(getAllClientConfigListSaga);
  }
}

const watchers = [fork(getAllClientConfigListWatcherSaga)];

export default watchers;
